export default [{
	name:'personal',
	path: '/personal/index',
	component: resolve => require(['@/views/personal/index'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		ticketType: 'personal'
	}
}, {
	path: '/personal/fillinfo',
	component: resolve => require(['@/views/personal/fillInfo'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		needLogin: true,
		ticketType: 'personal'
	}
}, {
	path: '/personal/checkinfo',
	component: resolve => require(['@/views/personal/checkInfo'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		needLogin: true,
		ticketType: 'personal'
	}
}, {
	path: '/personal/success',
	component: resolve => require(['@/views/personal/success'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		needLogin: true,
		ticketType: 'personal'
	}
}, {
	path: '/personal/record',
	component: resolve => require(['@/views/personal/record'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		needLogin: true,
		ticketType: 'personal'
	}
}, {
	path: '/personal/order/detail',
	component: resolve => require(['@/views/personal/orderDetail'], resolve),
	meta: {
		title: '智慧博物馆票务管理系统',
		needLogin: true,
		ticketType: 'personal'
	}
}]


// WEBPACK FOOTER //
// ./src/router/modules/personal.js